import { $ } from '../util/DOM';

const regex = {
  not_digits: /[^\d]+/g,
  iscnpj: /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})?/,
};

const isCNPJ = (val) => regex.iscnpj.test(
  val.replace(regex.not_digits, ''),
);

function validateRequiredCheckboxes(elements) {
  const isValid = elements.some((el) => el.checked);
  const el = elements[elements.length - 1];

  if (isValid) {
    el.removeAttribute('required');
  } else {
    el.setAttribute('required', 'required');
  }
}

function manageRequiredCheckbox(name) {
  if (!name) {
    return;
  }

  const elements = Array.prototype.slice.call(document.getElementsByName(name));

  validateRequiredCheckboxes(elements);

  elements.forEach((el) => {
    el.addEventListener('change', () => {
      validateRequiredCheckboxes(elements);
    });
  });
}

function validarCPF(val) {
  const strCPF = val.replace(regex.not_digits, '');
  let Soma;
  let Resto;
  Soma = 0;
  if (strCPF === '00000000000') {
    return false;
  }

  for (let i = 1; i <= 9; i += 1) {
    Soma += parseInt(strCPF.substring(i - 1, i), 10) * (11 - i);
  }
  Resto = (Soma * 10) % 11;

  if ((Resto === 10) || (Resto === 11)) {
    Resto = 0;
  }
  if (Resto !== parseInt(strCPF.substring(9, 10), 10)) {
    return false;
  }

  Soma = 0;
  for (let i = 1; i <= 10; i += 1) {
    Soma += parseInt(strCPF.substring(i - 1, i), 10) * (12 - i);
  }
  Resto = (Soma * 10) % 11;

  if ((Resto === 10) || (Resto === 11)) {
    Resto = 0;
  }
  if (Resto !== parseInt(strCPF.substring(10, 11), 10)) {
    return false;
  }
  return true;
}

function validarCNPJ(value) {
  const cnpj = value.replace(regex.not_digits, '');

  // Valida a quantidade de caracteres
  if (cnpj.length !== 14) return false;

  // Elimina inválidos com todos os caracteres iguais
  if (/^(\d)\1+$/.test(cnpj)) return false;

  // Cáculo de validação
  const t = cnpj.length - 2;
  const d = cnpj.substring(t);
  const d1 = parseInt(d.charAt(0), 10);
  const d2 = parseInt(d.charAt(1), 10);
  const calc = (x) => {
    const n = cnpj.substring(0, x);
    let y = x - 7;
    let s = 0;
    let r = 0;

    for (let i = x; i >= 1; i -= 1) {
      // eslint-disable-next-line no-plusplus
      s += n.charAt(x - i) * y--;
      if (y < 2) {
        y = 9;
      }
    }

    r = 11 - (s % 11);
    return r > 9 ? 0 : r;
  };

  return calc(t) === d1 && calc(t + 1) === d2;
}

const setValidity = (input, test, message) => () => {
  const msg = test(input.value) || input.value === '' ? '' : message;
  input.setCustomValidity(msg);
};

const setCPFValidity = (input) => setValidity(
  input, validarCPF, 'O CPF informado não é válido',
);

const setCNPJValidity = (input) => setValidity(
  input, validarCNPJ, 'O CNPJF informado não é válido.',
);

const initFormValidations = () => {
  $('[data-checkbox-required]').forEach((container) => {
    const checkboxName = container.getAttribute('data-checkbox-required');
    manageRequiredCheckbox(checkboxName);
  });

  $('[data-mask="cpf"]').forEach((input) => {
    input.addEventListener('input', setCPFValidity(input));
  });

  $('[data-mask="cnpj"').forEach((input) => {
    input.addEventListener('input', setCNPJValidity(input));
  });

  $('[data-mask="cpfcnpj"]').forEach((input) => {
    input.addEventListener('input', () => {
      if (isCNPJ(input.value)) {
        setCNPJValidity(input);
        return;
      }
      setCPFValidity(input);
    });
  });

  $('input[type="file"]').forEach((input) => {
    const formats = input.getAttribute('data-accept');
    const maxSize = parseInt(input.getAttribute('data-max-size'), 10);
    const extRX = /\.([^.]+)$/;
    const ext = (file) => (file.name.match(extRX)[1] || '').toLowerCase();
    const constraints = {
      format: () => {
        if (!formats) {
          return $(input.files);
        }
        const validFormats = formats.split(',');
        return $(input.files).filter((f) => validFormats.includes(ext(f)));
      },
      size: () => {
        if (!maxSize) {
          return $(input.files);
        }

        return $(input.files).filter((f) => f.size < maxSize);
      },
    };

    input.addEventListener('change', () => {
      const validation = {
        format: constraints.format().length === input.files.length,
        size: constraints.size().length === input.files.length,
      };
      const message = [
        validation.format
          ? ''
          : `Arquivo incorreto. Selecione um formato válido: ${formats.replace(/,/g, ', ')}`,
        validation.size
          ? ''
          : 'Limite de upload excedido. Selecione um arquivo menor.',
      ]
        .filter((m) => !!m)
        .join(' ')
        .trim();

      input.setCustomValidity(message);
    });
  });
};

export default initFormValidations;
